import { useMemo } from 'react';
import { useGetPlansListQuery } from '@/store/services/plans';
// import { PlanObject } from '@/store/services/plans';

/**
 * Custom hook to get the current plan from the plans list
 * @returns {PlanObject | null} The current plan info if found, null otherwise
 */
function useGetCurrentPlan() {
	const { data: plansResponse, isLoading, error } = useGetPlansListQuery(undefined);

	const currentPlanInfo = useMemo(() => {
		if (!plansResponse?.data) {
			return null;
		}

		const currentPlan = plansResponse.data.find((plan) => plan.isCurrentPlan === true);

		return currentPlan || null;
	}, [plansResponse?.data]);

	return {
		currentPlanInfo,
		isLoading,
		error
	};
}

export default useGetCurrentPlan;
